
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

const SignupSuccess = () => {
  const navigate = useNavigate();
  
  const goToDashboard = () => {
    navigate('/login');
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={false} />
      
      <main className="flex-grow flex items-center justify-center py-10 px-4 bg-gray-50">
        <div className="max-w-xl w-full bg-white p-8 rounded-xl shadow-md text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle className="h-20 w-20 text-green-500" />
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Success!</h1>
          
          <p className="text-lg text-gray-600 mb-6">
            Your business account has been successfully created. You'll receive an email with login instructions shortly.
          </p>
          
          <div className="space-y-4">
            <Button 
              size="lg" 
              className="w-full" 
              onClick={goToDashboard}
            >
              Continue to Login
            </Button>
            
            <p className="text-sm text-gray-500">
              If you don't receive the email, please check your spam folder or contact our support team.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default SignupSuccess;
